import { render, staticRenderFns } from "./PieChartGraph.vue?vue&type=template&id=79dd7690&scoped=true&"
import script from "./PieChartGraph.vue?vue&type=script&lang=js&"
export * from "./PieChartGraph.vue?vue&type=script&lang=js&"
import style0 from "./PieChartGraph.vue?vue&type=style&index=0&id=79dd7690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dd7690",
  null
  
)

export default component.exports